import type { VaultAppToastEvent } from '@nebula/shared-vault/data-access';

export function buildIngestProjectCreatedToast(projectName: string): VaultAppToastEvent {
  return {
    type: 'success',
    title: 'Expediente creado',
    message: `El expediente «${projectName}» se registró correctamente.`,
    duration: 3500,
  };
}

export function buildIngestProjectUpdatedToast(projectName: string): VaultAppToastEvent {
  return {
    type: 'success',
    title: 'Expediente actualizado',
    message: `Los cambios en «${projectName}» se guardaron correctamente.`,
    duration: 3500,
  };
}
